import {HttpEvent, HttpEventType, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpRequest, HttpResponseBase} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store'
import {tokenSelector} from '../store/samoobsluga/samoobsluga.selectors'
import {map, mergeMap, take, tap} from 'rxjs/operators'
import {zaktualizujToken} from '../store/samoobsluga/samoobsluga.actions'

@Injectable()
export class SecurityInterceptor implements HttpInterceptor {
  private static readonly API_URL_FRAGMENT = '/sag/'
  private static readonly JWT_HEADER = 'Authorization'

  constructor(private store: Store) {
    this.aktualizujToken = this.aktualizujToken.bind(this)
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isApiUrl(req.url)) {
      return this.store.pipe(
        select(tokenSelector),
        take(1),
        map(token => this.utworzRequestZTokenemJwt(req, token)),
        mergeMap((jsonReq: HttpRequest<any>) => next.handle(jsonReq)),
        tap(this.aktualizujToken)
      )
    } else {
      return next.handle(req)
    }
  }

  private utworzRequestZTokenemJwt(req: HttpRequest<any>, token: string): HttpRequest<any> {
    const jsonReq: HttpRequest<any> = req.clone({
      setHeaders: {
        [SecurityInterceptor.JWT_HEADER] : token
      }
    });
    return jsonReq;
  }

  private aktualizujToken(response: HttpEvent<any>): void {
    if (response instanceof HttpResponseBase) {
      const newToken = (response as HttpHeaderResponse).headers.get(SecurityInterceptor.JWT_HEADER)
      if (newToken != null) {
        this.store.dispatch(zaktualizujToken({token: newToken}))
      }
   }
  }

  private isApiUrl(url: string): boolean {
    return url.indexOf(SecurityInterceptor.API_URL_FRAGMENT) > -1;
  }
}
